/* eslint-disable prefer-promise-reject-errors */
import omnivore from '@mapbox/leaflet-omnivore';
import shp from 'shpjs';
import tokml from 'tokml';
import fileToArrayBuffer from 'file-to-array-buffer';
import kmzToKml from './KmzToKml';

const fileTypes = ['wkt', 'kml', 'kmz', 'shp', 'zip'];

export default {
    async read(extension, content, rawFile) {
        let arquivoFormatoValido = fileTypes.indexOf(extension) > -1;

        if (!arquivoFormatoValido) {
            return new Promise((resolve, reject) => {
                reject('Tipo de arquivo não permitido.');
            });
        }

        let data = null;

        switch (extension) {
            case 'wkt':
                data = omnivore.wkt.parse(content);
                break;

            case 'kml':
                data = omnivore.kml.parse(content);
                break;

            case 'kmz':
                await kmzToKml.parse(rawFile).then(kmlDom => {
                    data = omnivore.kml.parse(kmlDom);
                });
                break;

            case 'zip':
                let arrayBuffer = null;

                await fileToArrayBuffer(rawFile).then(buffer => {
                    arrayBuffer = buffer;
                });

                const geojson = await shp(arrayBuffer);
                const kml = tokml(geojson);

                data = omnivore.kml.parse(kml);

                break;

            case 'shp':
                return new Promise((resolve, reject) => {
                    reject(
                        'Faça o upload de um zip com os arquivos do shapefile'
                    );
                });
        }

        return new Promise((resolve, reject) => {
            resolve(data);
        });
    }
};
